<script setup>
import { computed, inject, ref } from 'vue';
import { __, decodeHTMLEntities } from '@/utils';
import Modal from "@components/modal.vue";
import UpdateAccountForm from './updateAccountForm.vue';

const { details, features } = inject('account');

const modal = ref(false);
const accountDetails = ref(details.value);

const currentAddress = computed(() => {
    return `${accountDetails.value?.address?.street}, ${accountDetails.value?.address?.house_number}, ${accountDetails.value?.address?.city}`
})

const handeUpdate = (newDetails) => {
    accountDetails.value = newDetails;
    details.value = newDetails;
}
</script>
<template>
    <div>
        <h4 class="details-item-header">{{ __('Subscription details') }}</h4>
        <p>
            <strong>{{ __('full name') }}:</strong> {{ decodeHTMLEntities(accountDetails?.first_name) }} {{ decodeHTMLEntities(accountDetails?.last_name) }}<br />
            <strong>{{ __('ID.') }}:</strong> {{ accountDetails?.personal_id }}<br />
            <strong>{{ __('Phone Number') }}:</strong> {{ accountDetails?.phone }}<br />
            <strong>{{ __('mail adress') }}:</strong> {{ accountDetails?.email }}<br />
            <strong>{{ __('Subscriber address') }}:</strong> {{ decodeHTMLEntities(currentAddress) }}<br />
        </p>   
    </div>
    <button type="button" class="details-item-button" @click="modal = true" v-if="features.accountEdit">
        <img class="link-underline" :src="`${theme_path.url}/resources/images/svg/icon-edit2.svg`" /> {{ __('Edit') }}
    </button>

    <Modal :isActive="modal" @close="modal = false" class="popup--subscription">
        <template #head>
            <h2>{{ __('Edit subscription details') }}</h2>
        </template>
        <template #body>
            <UpdateAccountForm @updatedDetails="handeUpdate" @close="modal = false"/>
        </template>
    </Modal>
</template>